import "core-js/modules/web.dom-collections.iterator.js";
import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import OverlayLoader from './components/overlay-loader';
import configureStore from './configure-store';
import KYCFormComponent from './containers/kyc-form';
import { KycContext, KycProcess } from './generated-types';
import restClient from './restClient';
const store = configureStore();
const clientToken = (owner, publicId, process) => {
  const csvString = "".concat(owner, ",").concat(publicId, ",").concat(process, ",client");
  return btoa(csvString);
};
const clientTokenSimple = (owner, process, publicId) => {
  const csvString = "".concat(owner, ",").concat(publicId !== null && publicId !== void 0 ? publicId : 'UNKNOWN', ",").concat(process, ",client");
  return btoa(csvString);
};
const KYCForm = _ref => {
  let {
    token,
    statusCallback,
    finishedText,
    onFinishRedirectURL,
    onCaseCompletionFailedURL,
    hidePrintInformationInFinalPage = false,
    showStepIndicator,
    goBackText,
    goBackCallback,
    hideOnFetchFail,
    context,
    minimumCharsInCommentFields
  } = _ref;
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(KYCFormComponent, {
    token: token,
    statusCallback: statusCallback,
    finishedText: finishedText,
    onFinishRedirectURL: onFinishRedirectURL,
    onCaseCompletionFailedURL: onCaseCompletionFailedURL,
    hidePrintInformationInFinalPage: hidePrintInformationInFinalPage,
    showStepIndicator: showStepIndicator,
    goBackText: goBackText,
    goBackCallback: goBackCallback,
    hideOnFetchFail: hideOnFetchFail,
    context: context,
    minCommentLength: minimumCharsInCommentFields
  }));
};
const LoadingForm = _ref2 => {
  let {
    birthDate,
    mask,
    context,
    process,
    statusCallback
  } = _ref2;
  const [token, setToken] = useState(undefined);
  useEffect(() => {
    restClient.tokenForProcess({
      mask,
      birthDate,
      context,
      process
    }).then(kycToken => setToken(kycToken.token));
  }, [birthDate, mask, context, process]);
  return token ? /*#__PURE__*/React.createElement(KYCForm, {
    token: token,
    statusCallback: statusCallback,
    context: context
  }) : /*#__PURE__*/React.createElement(OverlayLoader, null);
};
const BecomePrivateCustomerForm = _ref3 => {
  let {
    owner,
    publicId,
    statusCallback,
    finishedText,
    onFinishRedirectURL,
    hidePrintInformationInFinalPage = true,
    showStepIndicator,
    goBackText,
    goBackCallback,
    minimumCharsInCommentFields
  } = _ref3;
  return /*#__PURE__*/React.createElement(KYCForm, {
    token: clientToken(owner, publicId, KycProcess.BECOME_PRIVATE_CUSTOMER),
    statusCallback: statusCallback,
    finishedText: finishedText,
    onFinishRedirectURL: onFinishRedirectURL,
    hidePrintInformationInFinalPage: hidePrintInformationInFinalPage,
    showStepIndicator: showStepIndicator,
    goBackText: goBackText,
    goBackCallback: goBackCallback,
    minimumCharsInCommentFields: minimumCharsInCommentFields,
    context: KycContext.CUSTOMER_ONBOARDING
  });
};
const BecomePrivateCustomerFormV2 = _ref4 => {
  let {
    birthDate,
    mask,
    statusCallback
  } = _ref4;
  return /*#__PURE__*/React.createElement(LoadingForm, {
    context: KycContext.CUSTOMER_ONBOARDING,
    process: KycProcess.BECOME_PRIVATE_CUSTOMER,
    birthDate: birthDate,
    mask: mask,
    statusCallback: statusCallback
  });
};
const BecomeDisponentCustomerForm = _ref5 => {
  let {
    birthDate,
    mask,
    statusCallback
  } = _ref5;
  return /*#__PURE__*/React.createElement(LoadingForm, {
    context: KycContext.CUSTOMER_ONBOARDING_DISPONENT,
    process: KycProcess.BECOME_DISPONENT_CUSTOMER,
    birthDate: birthDate,
    mask: mask,
    statusCallback: statusCallback
  });
};
const BecomeGuarantorCustomerForm = _ref6 => {
  let {
    birthDate,
    mask,
    statusCallback
  } = _ref6;
  return /*#__PURE__*/React.createElement(LoadingForm, {
    context: KycContext.CUSTOMER_ONBOARDING_GUARANTOR,
    process: KycProcess.BECOME_GUARANTOR_CUSTOMER,
    birthDate: birthDate,
    mask: mask,
    statusCallback: statusCallback
  });
};
const BecomeChildCustomerForm = _ref7 => {
  let {
    birthDate,
    mask,
    statusCallback
  } = _ref7;
  return /*#__PURE__*/React.createElement(LoadingForm, {
    context: KycContext.CUSTOMER_ONBOARDING,
    process: KycProcess.BECOME_CHILD_CUSTOMER,
    birthDate: birthDate,
    mask: mask,
    statusCallback: statusCallback
  });
};
const BecomeCorporateCustomerForm = _ref8 => {
  let {
    owner,
    publicId,
    statusCallback,
    finishedText,
    onFinishRedirectURL,
    hidePrintInformationInFinalPage = true,
    showStepIndicator,
    goBackText,
    goBackCallback,
    minimumCharsInCommentFields
  } = _ref8;
  return /*#__PURE__*/React.createElement(KYCForm, {
    token: clientToken(owner, publicId, KycProcess.BECOME_CORPORATE_CUSTOMER),
    statusCallback: statusCallback,
    finishedText: finishedText,
    onFinishRedirectURL: onFinishRedirectURL,
    hidePrintInformationInFinalPage: hidePrintInformationInFinalPage,
    showStepIndicator: showStepIndicator,
    goBackText: goBackText,
    goBackCallback: goBackCallback,
    minimumCharsInCommentFields: minimumCharsInCommentFields,
    context: KycContext.CUSTOMER_ONBOARDING
  });
};

// This might be unused, it probably uses kyc-app.tsx when coming from task room. Remove?
const RenewalPrivateCustomerForm = _ref9 => {
  let {
    owner,
    publicId,
    statusCallback,
    finishedText,
    onFinishRedirectURL,
    hidePrintInformationInFinalPage = true,
    showStepIndicator,
    goBackText,
    goBackCallback,
    minimumCharsInCommentFields
  } = _ref9;
  return /*#__PURE__*/React.createElement(KYCForm, {
    token: clientToken(owner, publicId, KycProcess.RENEWAL_PRIVATE),
    statusCallback: statusCallback,
    finishedText: finishedText,
    onFinishRedirectURL: onFinishRedirectURL,
    hidePrintInformationInFinalPage: hidePrintInformationInFinalPage,
    showStepIndicator: showStepIndicator,
    goBackText: goBackText,
    goBackCallback: goBackCallback,
    minimumCharsInCommentFields: minimumCharsInCommentFields,
    context: KycContext.SIGNING_ROOM
  });
};

// This might be unused, it probably uses kyc-app.tsx when coming from task room. Remove?
const RenewalCorporateCustomerForm = _ref10 => {
  let {
    owner,
    publicId,
    statusCallback,
    finishedText,
    onFinishRedirectURL,
    hidePrintInformationInFinalPage = true,
    showStepIndicator,
    goBackText,
    goBackCallback,
    minimumCharsInCommentFields
  } = _ref10;
  return /*#__PURE__*/React.createElement(KYCForm, {
    token: clientToken(owner, publicId, KycProcess.RENEWAL_CORPORATE),
    statusCallback: statusCallback,
    finishedText: finishedText,
    onFinishRedirectURL: onFinishRedirectURL,
    hidePrintInformationInFinalPage: hidePrintInformationInFinalPage,
    showStepIndicator: showStepIndicator,
    goBackText: goBackText,
    goBackCallback: goBackCallback,
    minimumCharsInCommentFields: minimumCharsInCommentFields,
    context: KycContext.SIGNING_ROOM
  });
};
const CreditCardForm = _ref11 => {
  let {
    publicId,
    statusCallback,
    onFinishRedirectURL,
    goBackText,
    goBackCallback,
    minimumCharsInCommentFields
  } = _ref11;
  return /*#__PURE__*/React.createElement(KYCForm, {
    token: clientTokenSimple('9812', KycProcess.CREDIT_CARD, publicId),
    statusCallback: statusCallback,
    onFinishRedirectURL: onFinishRedirectURL,
    hidePrintInformationInFinalPage: true,
    goBackText: goBackText,
    goBackCallback: goBackCallback,
    minimumCharsInCommentFields: minimumCharsInCommentFields,
    context: KycContext.EKB_CLIENT
  });
};
const CreditLoanForm = _ref12 => {
  let {
    publicId,
    statusCallback,
    onFinishRedirectURL,
    goBackText,
    goBackCallback,
    minimumCharsInCommentFields
  } = _ref12;
  return /*#__PURE__*/React.createElement(KYCForm, {
    token: clientTokenSimple('9812', KycProcess.CREDIT_LOAN, publicId),
    statusCallback: statusCallback,
    onFinishRedirectURL: onFinishRedirectURL,
    hidePrintInformationInFinalPage: true,
    goBackText: goBackText,
    goBackCallback: goBackCallback,
    minimumCharsInCommentFields: minimumCharsInCommentFields,
    context: KycContext.EKB_CLIENT
  });
};
const CarLoanForm = _ref13 => {
  let {
    publicId,
    statusCallback,
    onFinishRedirectURL,
    goBackText,
    goBackCallback,
    minimumCharsInCommentFields
  } = _ref13;
  return /*#__PURE__*/React.createElement(KYCForm, {
    token: clientTokenSimple('9812', KycProcess.CAR_LOAN, publicId),
    statusCallback: statusCallback,
    onFinishRedirectURL: onFinishRedirectURL,
    hidePrintInformationInFinalPage: true,
    goBackText: goBackText,
    goBackCallback: goBackCallback,
    minimumCharsInCommentFields: minimumCharsInCommentFields,
    context: KycContext.EKB_CLIENT
  });
};
export { BecomePrivateCustomerForm, BecomePrivateCustomerFormV2, BecomeDisponentCustomerForm, BecomeGuarantorCustomerForm, BecomeChildCustomerForm, BecomeCorporateCustomerForm, RenewalCorporateCustomerForm, RenewalPrivateCustomerForm, CreditCardForm, CreditLoanForm, CarLoanForm, KycProcess, KycContext };
export default KYCForm;